import {CommandActionInterface, CommandActionBase} from '../command-action';
import {Participant} from "../../../providers/global.service";
import {filter} from "rxjs/operators";
import {GlobalServiceProvider} from "../../../providers/global.service";
import {Component, Inject, NgModule} from "@angular/core";



export class ParticipantListCmdAction extends CommandActionBase implements CommandActionInterface{

  componentName:string;
  commandString:string;
  global:GlobalServiceProvider;

  public participantObservable;
  public participants:Array<Participant> = [];

  constructor(){
    super();
  }

  do(commandString?){
    this.commandString = commandString;

    return new Promise( (resolve, reject)=>{
      this.participantObservable = this.global.getParticipantObservable();

      this.participantObservable
        .pipe(filter( (p:any) => {

          let isNew = true;
          this.participants.forEach(myParticipant => {
            if (myParticipant.username === p.username) isNew = false;
          });
          return isNew;
        })).subscribe((participant: Participant) => {
        this.participants.push(participant);
      });

      this.global.fetchParticipants();
      resolve({commandString: this.commandString, commandAction: this});
    });


  }

  getResult(){
    return this.participants
  }

  destroy() {
    this.participantObservable.unsubscribe();
  }


  public static getNew(){
    return new ParticipantListCmdAction();
  }

}



// WEBPACK FOOTER //
// ./src/components/commands/participant-list-cmd/participant-list-cmd-action.ts